import type { ReactElement } from 'react'
import { Link } from 'react-router'
import { useT } from '../i18n/useI18n'

export default function NotFound(): ReactElement {
  const t = useT()
  return (
    <section className="section text-center">
      <div className="container">
        <div className="feature-icon mx-auto mb-3">
          <i className="bi bi-compass"></i>
        </div>
        <h1 className="display-5 mb-3">{t('notFound.heading')}</h1>
        <p className="lead text-muted mb-4">{t('notFound.body')}</p>
        <Link to="/" className="btn btn-primary">
          <i className="bi bi-house me-2"></i>
          {t('notFound.cta')}
        </Link>
      </div>
    </section>
  )
}
